var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',{staticStyle:{"height":"800px"}},[_c('el-container',[_c('el-main',[_c('div',[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }